/**
 * @module localStorage
 * @since 2.0.0
 */

import { Storage } from '../__Storage';

/**
 * A wrapper around the native `localStorage`, failsafing usage for non-compliant browsers (e.g. incognito Safari), and basic methods.
 * @type {Storage}
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Window/localStorage
 */
export const localStorage = new Storage('localStorage');
